import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["variants"]
  
  connect() {
    this.setupFormValidation()
  }
  
  // NOUVEAU: Nettoyer les variantes vides avant la soumission
  setupFormValidation() {
    const form = this.element.closest('form')
    if (form) {
      form.addEventListener('submit', (e) => {
        this.cleanupEmptyVariants()
      })
    }
  }
  
  cleanupEmptyVariants() {
    // Parcourir tous les formulaires de variantes
    const variants = this.variantsTarget.querySelectorAll('.variant-form')
    
    variants.forEach(variantForm => {
      const sizeInput = variantForm.querySelector('input[name*="[size]"]')
      const priceInput = variantForm.querySelector('input[name*="[price]"]')
      const destroyCheckbox = variantForm.querySelector('input[type="checkbox"][name*="[_destroy]"]')
      
      // Si la variante est vide ET pas marquée pour suppression
      const isEmpty = (!sizeInput || !sizeInput.value.trim()) && (!priceInput || !priceInput.value)
      
      if (isEmpty && destroyCheckbox) {
        // Marquer automatiquement pour suppression
        destroyCheckbox.checked = true
      }
    })
  }
  
  // NOUVEAU: Supprimer rapidement une variante
  removeVariant(event) {
    event.preventDefault()
    
    const variantForm = event.currentTarget.closest('.variant-form')
    if (!variantForm) return
    
    const destroyCheckbox = variantForm.querySelector('input[type="checkbox"][name*="[_destroy]"]')
    
    if (destroyCheckbox) {
      destroyCheckbox.checked = true
      variantForm.style.opacity = '0.5'
      variantForm.style.textDecoration = 'line-through'
    }
  }
  
  add(event) {
    event.preventDefault()
    
    // Créer un ID unique basé sur le timestamp
    const newId = new Date().getTime()
    
    // Essayer de cloner un variant existant
    const existingVariant = this.variantsTarget.querySelector('.variant-form')
    
    if (existingVariant) {
      // Cas 1: Il y a au moins un variant - on le clone
      
      const newForm = existingVariant.cloneNode(true)
      
      // Réinitialiser TOUS les inputs
      newForm.querySelectorAll('input').forEach(input => {
        if (input.type === 'text' || input.type === 'number') {
          input.value = ''
        } else if (input.type === 'checkbox') {
          input.checked = false
        }
      })
      
      // Remplacer les indices dans les noms d'attributs et IDs
      const fieldsToUpdate = newForm.querySelectorAll('[name*="variants_attributes"], [id*="variants_attributes"]')
      
      fieldsToUpdate.forEach(field => {
        // Mettre à jour le name
        if (field.name) {
          field.name = field.name.replace(/variants_attributes\]\[\d+\]/, `variants_attributes][${newId}]`)
        }
        
        // Mettre à jour l'ID
        if (field.id) {
          field.id = field.id.replace(/parfum_variants_attributes_\d+/, `parfum_variants_attributes_${newId}`)
        }
        
        // Mettre à jour les labels associés (for attribute)
        if (field.tagName === 'INPUT') {
          const associatedLabel = newForm.querySelector(`label[for="${field.id}"]`)
          if (associatedLabel) {
            associatedLabel.setAttribute('for', field.id)
          }
        }
      })
      
      this.variantsTarget.appendChild(newForm)
      
    } else {
      // Cas 2: Aucun variant existant - créer un formulaire vide de zéro
      
      const newForm = document.createElement('div')
      newForm.className = 'variant-form mb-3 border p-3 rounded'
      newForm.innerHTML = `
        <div class="row">
          <div class="col-md-6">
            <label for="parfum_variants_attributes_${newId}_size" class="form-label">Contenance (ex: 10ml, 20ml, 50ml)</label>
            <input type="text" name="parfum[variants_attributes][${newId}][size]" id="parfum_variants_attributes_${newId}_size" class="form-control" required placeholder="10ml">
            <div class="invalid-feedback">Veuillez spécifier une contenance</div>
          </div>
          <div class="col-md-6">
            <label for="parfum_variants_attributes_${newId}_price" class="form-label">Prix (TND)</label>
            <input type="number" step="0.01" name="parfum[variants_attributes][${newId}][price]" id="parfum_variants_attributes_${newId}_price" class="form-control" required min="0.01">
            <div class="invalid-feedback">Veuillez spécifier un prix supérieur à 0</div>
          </div>
        </div>
        <div class="form-check mt-2">
          <input type="hidden" name="parfum[variants_attributes][${newId}][_destroy]" value="0">
          <input type="checkbox" name="parfum[variants_attributes][${newId}][_destroy]" value="1" id="parfum_variants_attributes_${newId}_destroy" class="form-check-input">
          <label for="parfum_variants_attributes_${newId}_destroy" class="form-check-label">Supprimer cette contenance</label>
        </div>
      `
      
      this.variantsTarget.appendChild(newForm)
    }
  }
}